import { Client } from '../../client/Client';
import { DIPLOMAS_ENDPOINT } from '../../config/Client';

export class DiplomasController {
  static verify(hash) {
    return Client.get(`${DIPLOMAS_ENDPOINT}/verify/${hash}`);
  }
}
